// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC7eEXmhN0538-uwY0141dtWlHJ3_fUmcQ",
  authDomain: "devcorepanel.firebaseapp.com",
  projectId: "devcorepanel",
  storageBucket: "devcorepanel.firebasestorage.app",
  messagingSenderId: "17970244551",
  appId: "1:17970244551:web:6414af2abdfd9d8eaec7e2",
  measurementId: "G-0FESKV0SVJ"
};

// Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export default firebaseConfig;